module.exports = __webpack_public_path__ + "img/spacer.3ba1b129.png";